"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _hooks = require("../../hooks");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
const _excluded = ["children", "type", "datasets"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var htmlType = /*#__PURE__*/function (htmlType) {
  htmlType["default"] = "default";
  htmlType["title"] = "title";
  htmlType["title-2"] = "title-2";
  htmlType["title-3"] = "title-3";
  htmlType["title-4"] = "title-4";
  htmlType["title-5"] = "title-5";
  htmlType["title-6"] = "title-6";
  htmlType["description"] = "description";
  htmlType["helper"] = "helper";
  htmlType["link"] = "link";
  htmlType["error"] = "error";
  return htmlType;
}(htmlType || {});
const defaultProps = {
  type: htmlType.default,
  align: 'left',
  datasets: {},
  size: 0,
  afterStyles: {
    content: '',
    size: 12,
    weight: 300,
    color: ''
  }
};
function Typography(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      children,
      type,
      datasets
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  const dataAttributes = (0, _hooks.useDataset)(datasets);
  const Component = (0, _react.useMemo)(() => {
    if (type === htmlType.title) return Title;
    if (type === htmlType['title-2']) return Title2;
    if (type === htmlType['title-3']) return Title3;
    if (type === htmlType['title-4']) return Title4;
    if (type === htmlType['title-5']) return Title5;
    if (type === htmlType['title-6']) return Title6;
    if (type === htmlType.helper) return Small;
    if (type === htmlType.link) return Link;
    if (type === htmlType.error) return Error;
    return Default;
  }, [type]);
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    type: type
  }, dataAttributes, restOfProps), children);
}
const addAfterStyles = function () {
  let {
    content,
    size,
    weight,
    color
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (content === null || content === void 0 ? void 0 : content.length) >= 1 ? "\n        &::after {\n          content: '".concat(content, "';\n          font-size: ").concat(size, "px;\n          font-weight: ").concat(weight, ";\n          ").concat(Boolean(color) ? "color: ".concat(color, ";") : '', "\n        }\n      ") : '';
};
const defaultStyles = _ref => {
  let {
    weight = 700,
    theme = {},
    align = 'left',
    color,
    numberOfLines,
    lineHeight,
    letterSpacing,
    afterStyles
  } = _ref;
  return "\n  text-align: ".concat(align, ";\n  font-weight: ").concat(weight, ";\n  color: ").concat(color || theme.colors.FONT.TITLE, ";\n  ").concat(lineHeight ? "line-height: ".concat(lineHeight, "px;") : '', "\n  ").concat(letterSpacing ? "letter-spacing: ".concat(letterSpacing, "px;") : '', "\n\n  ").concat(numberOfLines ? "\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-line-clamp: ".concat(numberOfLines, ";\n        -webkit-box-orient: vertical;\n      ") : '', "\n\n  ").concat(addAfterStyles(_objectSpread(_objectSpread({}, defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.afterStyles), afterStyles)), "\n");
};
const Title = _styled.default.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n"])), props => defaultStyles(props), _ref2 => {
  let {
    size
  } = _ref2;
  return size || 30;
}, _ref3 => {
  let {
    styles
  } = _ref3;
  return styles;
});
const Title2 = _styled.default.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  @media screen and (min-width: 768px) {\n    font-size: 38px;\n    line-height: 45px;\n  }\n\n  ", "\n"])), props => defaultStyles(props), _ref4 => {
  let {
    size
  } = _ref4;
  return size || 25;
}, _ref5 => {
  let {
    styles
  } = _ref5;
  return styles;
});
const Title3 = _styled.default.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n"])), props => defaultStyles(props), _ref6 => {
  let {
    size
  } = _ref6;
  return size || 20;
}, _ref7 => {
  let {
    styles
  } = _ref7;
  return styles;
});
const Title4 = _styled.default.h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n"])), props => defaultStyles(props), _ref8 => {
  let {
    size
  } = _ref8;
  return size || 18;
}, _ref9 => {
  let {
    styles
  } = _ref9;
  return styles;
});
const Title5 = _styled.default.h5(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n"])), props => defaultStyles(props), _ref0 => {
  let {
    size
  } = _ref0;
  return size || 18;
}, _ref1 => {
  let {
    styles
  } = _ref1;
  return styles;
});
const Title6 = _styled.default.h6(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n"])), props => defaultStyles(props), _ref10 => {
  let {
    size
  } = _ref10;
  return size || 18;
}, _ref11 => {
  let {
    styles
  } = _ref11;
  return styles;
});
const Default = _styled.default.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n\n  font-size: ", "px;\n\n  ", "\n\n  ", "\n"])), props => defaultStyles(_objectSpread(_objectSpread({
  weight: 400
}, props.type === 'description' ? {
  color: props === null || props === void 0 ? void 0 : props.theme.colors.FONT.DESCRIPTION
} : {}), props)), _ref12 => {
  let {
    size
  } = _ref12;
  return size || 16;
}, _ref13 => {
  let {
    bold
  } = _ref13;
  return bold && "\n    font-weight: bold;\n    color: #6B6B6C;\n  ";
}, _ref14 => {
  let {
    styles
  } = _ref14;
  return styles;
});
const Small = _styled.default.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n"])), props => defaultStyles(_objectSpread({
  weight: 400,
  color: props === null || props === void 0 ? void 0 : props.theme.colors.FONT.HELPER
}, props)), _ref15 => {
  let {
    size
  } = _ref15;
  return size || 13;
}, _ref16 => {
  let {
    styles
  } = _ref16;
  return styles;
});
const Link = _styled.default.a(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", "px;\n\n  ", "\n  ", "\n"])), props => defaultStyles(_objectSpread({
  weight: 400,
  color: props === null || props === void 0 ? void 0 : props.theme.colors.MAIN.PRIMARY
}, props)), _ref17 => {
  let {
    size
  } = _ref17;
  return size || 16;
}, _ref18 => {
  let {
    decoration
  } = _ref18;
  return decoration ? "text-decoration: ".concat(decoration, ";") : '';
}, _ref19 => {
  let {
    styles
  } = _ref19;
  return styles;
});
const Error = _styled.default.p(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", "\n\n  min-height: ", "px;\n  font-size: ", "px;\n  ", "\n"])), props => defaultStyles(_objectSpread({
  weight: 600,
  color: props === null || props === void 0 ? void 0 : props.theme.colors.MAIN.ERROR
}, props)), _ref20 => {
  let {
    size
  } = _ref20;
  return Math.max(size * 1.2, 14);
}, _ref21 => {
  let {
    size
  } = _ref21;
  return size || 10;
}, _ref22 => {
  let {
    styles
  } = _ref22;
  return styles;
});
var _default = exports.default = Typography;